import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { FrontService } from '../../front/front.service';
import { Select2OptionData } from 'ng2-select2';
import { MyDesktopService } from '../../services/mydesktop.service';
import { VaultService } from '../../services/vault.service';
import { GlobalService } from '../../services/global.service';
import { Subject } from 'rxjs';
import { DomainService } from '../../services/domain.service';

declare var $: any;
declare var swal: any;

@Component({
  selector: 'app-property-search',
  templateUrl: './property-search.component.html',
  styleUrls: ['./property-search.component.css']
})
export class PropertySearchComponent implements OnInit {
  destroy$: Subject<boolean> = new Subject<boolean>();
  loading = false;
  subLoading = true;
  activateInsertListing = false;
  loadingInsertListing = false;
  authUser: any;
  client: any;
  mdListingsForm: FormGroup;

  mdListings = [];
  is_local_search = 0;
  isMultipleOffice = false;
  clientAgents = [];

  price_sale: any[] = [];
  price_rent: any[] = [];

  canSearch = false;
  isDatePeriodNeeded = false;
  filterPeriodType = 'n/a';

  listingSearchValues: string;
  isSendToVault = false;
  vaultTemplateId = 0;
  mainColor = '';

  showDesignlyPreviousPage = false;
  showDesignlyNextPage = false;
  designlyPreviousLink = '';
  designlyNextLink = '';

  mdListingCount = 0;
  mdListingTotal = 0;
  mdListingPages = [];
  mdListingCurrentPage = 1;

  selectedListingIDs = [];
  selectedListings = [];

  mdSuburbs: any[] = [];
  mdTypes: any[] = [];
  mdClassifications: any[] = [];
  mdStatuses: any[] = [];
  mdCustomParams: any[] = [];

  _tmp_order_id: number;
  _tmp_order_images = {};

  listingImages: any[];
  oldPosImages: any[];
  newPosImages: any[];

  s2SuburbValue = '';
  s2SuburbData: Array<Select2OptionData>;
  s2SuburbOptions: Select2Options;

  s2ClassificationValue = '';
  s2ClassificationData: Array<Select2OptionData>;
  s2ClassificationOptions: Select2Options;
  s2StatusValue = '';
  s2StatusData: Array<Select2OptionData>;
  s2StatusOptions: Select2Options;
  s2StatusDisabled = true;
  s2SubStatusValue = '';
  s2SubStatusData: Array<Select2OptionData>;
  s2SubStatusOptions: Select2Options;
  s2SubStatusDisabled = true;
  s2AvailableValue = '1';
  s2AvailableData: Array<Select2OptionData>;
  s2AvailableOptions: Select2Options;
  s2AvailableDisabled = true;
  s2AgentIdValue = '';
  s2AgentIdData: Array<Select2OptionData>;
  s2AgentIdOptions: Select2Options;

  s2PriceFromValue = '';
  s2PriceFromData: Array<Select2OptionData>;
  s2PriceFromOptions: Select2Options;

  s2PriceToValue = '';
  s2PriceToData: Array<Select2OptionData>;
  s2PriceToOptions: Select2Options;

  s2BedFromValue = '';
  s2BedFromData: Array<Select2OptionData>;
  s2BedFromOptions: Select2Options;

  s2BedToValue = '';
  s2BedToData: Array<Select2OptionData>;
  s2BedToOptions: Select2Options;

  s2BathFromValue = '';
  s2BathFromData: Array<Select2OptionData>;
  s2BathFromOptions: Select2Options;

  s2BathToValue = '';
  s2BathToData: Array<Select2OptionData>;
  s2BathToOptions: Select2Options;

  s2CarFromValue = '';
  s2CarFromData: Array<Select2OptionData>;
  s2CarFromOptions: Select2Options;

  s2CarToValue = '';
  s2CarToData: Array<Select2OptionData>;
  s2CarToOptions: Select2Options;

  s2OrderByValue = 'modifydateDesc';
  s2OrderByData: Array<Select2OptionData>;
  s2OrderByOptions: Select2Options;

  s2OfficeIdValue = '';
  s2OfficeIdData: Array<Select2OptionData>;
  s2OfficeIdOptions: Select2Options;
  s2SelectingCategory = false;

  constructor(
    private myDesktopService: MyDesktopService,
    private vaultService: VaultService,
    public globalService: GlobalService,
    private domainService: DomainService
  ) { }

  @Input() page: string;
  ngOnInit() {
    this.authUser = this.globalService.authService.auth;
    this.client = this.authUser.client;
    this.initForm();

    this.is_local_search = this.client.is_local_search;

    this.s2SuburbOptions = {
      width: '100%',
      placeholder: 'Select a Suburb',
      allowClear: true,
      ajax: {
        headers: {
          'Authorization' : 'Bearer ' + this.authUser.__token
        },
        url: this.globalService.appConfig.API_ENDPOINT + '/locations',
        dataType: 'json',
        delay: 500,
        data: function (params) {
          return {
            name: params.term
          };
        },
        processResults: function (data, params) {
          const results = data.data.map(
            (obj) => {
              return {id: obj.name, text: obj.name};
            }
          );
          results.unshift({id: 'all', text: 'All Suburb'});

          return {
            results: results
          };
        },
        cache: true
      },
      minimumInputLength: 2
    };

    if (this.is_local_search) {
      this.s2SuburbOptions['multiple'] = true;
    }

    this.s2SuburbData = <any>[
      {id: '', text: 'Select a Suburb'},
      {id: ' ', text: 'Select a Suburb'}
    ];

    if ( this.authUser.provider === 'vaultre' ) {
      this.s2ClassificationData = <any>[
        {id: '', text: 'Select a Category'},
        {id: 'residential', text: 'Residential'},
        {id: 'commercial', text: 'Commercial'},
        {id: 'business', text: 'Business'},
        {id: 'rural', text: 'Rural'},
        {id: 'land', text: 'Land'},
        {id: 'holidayRental', text: 'Holiday Rental'},
      ];
    } else if ( this.authUser.provider === 'domain' ) {
      this.s2ClassificationData = <any>[
        {id: '', text: 'Select a Category'},
        {id: 'residential', text: 'Residential'},
        // {id: 'commercial', text: 'Commercial'},
        // {id: 'business', text: 'Business'}
      ];
    } else {
      this.s2ClassificationData = <any>[
        {id: '', text: 'Select a Category'},
        {id: 'residential', text: 'Residential'},
        {id: 'commercial', text: 'Commercial'},
        {id: 'business', text: 'Business'},
        {id: 'rural', text: 'Rural'},
        {id: 'livestock', text: 'Livestock'},
        {id: 'clearingsale', text: 'Clearing Sale'},
      ];
    }

    this.s2ClassificationOptions = {
      width: '100%',
      placeholder: 'Select a Category',
      minimumResultsForSearch: -1
    };

    this.s2StatusData = <any>[
      {id: '', text: 'Select a Type'},
      {id: ' ', text: 'All Types'},
      {id: 'listing', text: 'Sales'},
      {id: 'rental', text: 'Rental'},
      {id: 'auction', text: 'Auction'},
      {id: 'settled', text: 'Sold'},
      {id: 'leased', text: 'Leased'},
      {id: 'conditional', text: 'Conditional'},
      {id: 'unconditional', text: 'Unconditional'},
    ];

    this.s2StatusOptions = {
      width: '100%',
      placeholder: 'Select a Type',
      minimumResultsForSearch: -1
    };

    this.s2SubStatusData = <any>[];

    this.s2SubStatusOptions = {
      width: '100%',
      placeholder: 'Select a Sub Type',
      minimumResultsForSearch: -1,
    };

    this.s2SubStatusValue = 'management';

    this.s2SubStatusData = [
      {id: 'all', text: 'All'},
      {id: 'prospect', text: 'Prospect'},
      {id: 'appraisal', text: 'Appraisal'},
      {id: 'management', text: 'Management'},
    ];

    this.s2AgentIdData = <any>this.clientAgents.map(
      (obj) => {
        return {id: obj.agent_id, text: obj.firstname + ' ' + obj.lastname};
      }
    );
    this.s2AgentIdData.unshift({id: ' ', text: 'All Agents'});
    this.s2AgentIdData.unshift({id: '', text: 'Select an Agent'});

    this.s2AgentIdOptions = {
      width: '100%',
      placeholder: 'Select an Agent',
      minimumResultsForSearch: -1
    };

    this.s2AvailableOptions = {
      width: '100%',
      placeholder: 'Show Available Only',
      minimumResultsForSearch: -1
    };

    this.s2AvailableData = [
      {id: '1', text: 'Yes'},
      {id: '0', text: 'No'},
    ];

    if ( this.authUser.multiple.length > 1 ) {
      this.isMultipleOffice = true;
      this.s2OfficeIdData = <any>this.authUser.multiple.map(
        (obj) => {
          return {id: obj.groupid, text: obj.office};
        }
      );

      this.s2OfficeIdData.unshift({id: '', text: 'Select an Office'});

      this.s2OfficeIdOptions = {
        width: '100%',
        placeholder: 'Select an Office',
        minimumResultsForSearch: -1
      };
    }

    this.price_sale = [
      {id: '50000', text: '$50,000'},
      {id: '100000', text: '$100,000'},
      {id: '150000', text: '$150,000'},
      {id: '200000', text: '$200,000'},
      {id: '250000', text: '$250,000'},
      {id: '300000', text: '$300,000'},
      {id: '350000', text: '$350,000'},
      {id: '400000', text: '$400,000'},
      {id: '450000', text: '$450,000'},
      {id: '500000', text: '$500,000'},
      {id: '550000', text: '$550,000'},
      {id: '600000', text: '$600,000'},
      {id: '650000', text: '$650,000'},
      {id: '700000', text: '$700,000'},
      {id: '750000', text: '$750,000'},
      {id: '800000', text: '$800,000'},
      {id: '850000', text: '$850,000'},
      {id: '900000', text: '$900,000'},
      {id: '950000', text: '$950,000'},
      {id: '1000000', text: '$1,000,000'},
      {id: '1100000', text: '$1,100,000'},
      {id: '1200000', text: '$1,200,000'},
      {id: '1300000', text: '$1,300,000'},
      {id: '1400000', text: '$1,400,000'},
      {id: '1500000', text: '$1,500,000'},
      {id: '1600000', text: '$1,600,000'},
      {id: '1700000', text: '$1,700,000'},
      {id: '1800000', text: '$1,800,000'},
      {id: '1900000', text: '$1,900,000'},
      {id: '2000000', text: '$2,000,000'},
      {id: '2250000', text: '$2,250,000'},
      {id: '2500000', text: '$2,500,000'},
      {id: '2750000', text: '$2,750,000'},
      {id: '3000000', text: '$3,000,000'},
      {id: '3500000', text: '$3,500,000'},
      {id: '4000000', text: '$4,000,000'},
      {id: '5000000', text: '$5,000,000'},
      {id: '6000000', text: '$6,000,000'},
      {id: '7000000', text: '$7,000,000'},
      {id: '8000000', text: '$8,000,000'},
      {id: '9000000', text: '$9,000,000'},
      {id: '10000000', text: '$10,000,000'},
      {id: '11000000', text: '$11,000,000'},
      {id: '12000000', text: '$12,000,000'}
    ];

    this.price_rent = [
      {id: '50', text: '$50'},
      {id: '100', text: '$100'},
      {id: '150', text: '$150'},
      {id: '200', text: '$200'},
      {id: '250', text: '$250'},
      {id: '300', text: '$300'},
      {id: '350', text: '$350'},
      {id: '400', text: '$400'},
      {id: '450', text: '$450'},
      {id: '500', text: '$500'},
      {id: '550', text: '$550'},
      {id: '600', text: '$600'},
      {id: '650', text: '$650'},
      {id: '700', text: '$700'},
      {id: '750', text: '$750'},
      {id: '800', text: '$800'},
      {id: '850', text: '$850'},
      {id: '900', text: '$900'},
      {id: '950', text: '$950'},
      {id: '1000', text: '$1,000'},
      {id: '1500', text: '$1,500'},
      {id: '2000', text: '$2,000'},
      {id: '3000', text: '$3,000'},
      {id: '4000', text: '$4,000'},
      {id: '5000', text: '$5,000'}
    ];

    this.s2PriceFromData = this.s2PriceToData = <any>this.price_sale;

    this.s2PriceToData.unshift({id: ' ', text: 'Any'});
    this.s2PriceToData.unshift({id: '', text: 'Any'});

    this.s2PriceFromData = this.s2PriceToData;

    this.s2PriceToOptions = this.s2PriceFromOptions = {
      width: '100%',
      placeholder: 'Any',
      minimumResultsForSearch: -1
    };

    this.s2BedFromData = <any>[
      {id: '1', text: '1'},
      {id: '2', text: '2'},
      {id: '3', text: '3'},
      {id: '4', text: '4'},
      {id: '5', text: '5'},
    ];
    this.s2BedFromData.unshift({id: ' ', text: 'Any'});
    this.s2BedFromData.unshift({id: '', text: 'Any'});

    this.s2BedFromOptions = {
      width: '100%',
      placeholder: 'Any',
      minimumResultsForSearch: -1
    };

    this.s2BathFromData = this.s2CarFromData = this.s2BedToData = this.s2BathToData = this.s2CarToData = this.s2BedFromData;

    this.s2BathFromOptions = this.s2CarFromOptions = this.s2BedFromOptions;
    this.s2BathToOptions = this.s2CarToOptions = this.s2BedToOptions = this.s2BedFromOptions;

    let s2OrderByData = [];
    if ( this.authUser.provider === 'vaultre') {
      s2OrderByData = <any>[
        {id: 'modifydateDesc', text: 'Sort by: Newest Modified'},
        {id: 'modifydate', text: 'Sort by: Oldest Modified'}
      ];
    } else {
      s2OrderByData = <any>[
        {id: 'modifydateDesc', text: 'Sort by: Newest Modified'},
        {id: 'modifydate', text: 'Sort by: Oldest Modified'},
        {id: 'suburb', text: 'Sort by: Suburb (A-Z)'},
        {id: 'suburbDesc', text: 'Sort by: Suburb (Z-A)'},
      ];
    }

    this.s2OrderByData = s2OrderByData;

    this.s2OrderByOptions = {
      width: '100%',
      minimumResultsForSearch: -1
    };

    this.myDesktopService.myDesktopsListingsChanged
    .takeUntil(this.destroy$)
    .subscribe(
      (listings: any) => {
        $('#propertyList').find('.no-result').remove();

        if ( typeof listings !== 'undefined' && listings
          && typeof listings.data !== 'undefined' && listings.data && listings.data.length > 0 ) {
          this.loading = false;

          this.mdListings = listings.data;
          this.mdListingCount = listings.count;
          this.mdListingTotal = listings.total;

          this.mdListingPages = [];

          if ( this.mdListingTotal > 50 && this.globalService.authService.getApp() === 'MyDesign3' ) {
            const pageNumber = Math.ceil(this.mdListingTotal / 50);

            for (let page = 1; page <= pageNumber; page++) {
              this.mdListingPages.push(page);
            }
          }

          if ( this.globalService.authService.getApp() === 'Designly' && this.authUser.provider === 'vaultre' ) {
            this.showDesignlyPreviousPage = false;
            this.showDesignlyNextPage = false;

            if ( listings.prev !== null ) {
              this.designlyPreviousLink = listings.prev;
              this.showDesignlyPreviousPage = true;
            }

            if ( listings.next !== null ) {
              this.designlyNextLink = listings.next;
              this.showDesignlyNextPage = true;
            }
          }

          this.mdSuburbs = [];
          this.mdTypes = [];
          this.mdClassifications = [];
          this.mdStatuses = [];

          for (const listing of listings.data) {
            if ( typeof listing.address_suburb !== 'undefined' && !this.mdSuburbs.includes(listing.address_suburb)) {
              this.mdSuburbs.push(listing.address_suburb);
            }
            this.mdSuburbs.sort();
            if ( typeof listing.listing_type !== 'undefined' && !this.mdTypes.includes(listing.listing_type)) {
              this.mdTypes.push(listing.listing_type);
            }
          }
        }

        if ( typeof listings !== 'undefined' && listings
          && typeof listings.data !== 'undefined' && listings.data && listings.data.length === 0 ) {
          this.loading = false;
          this.mdListings = listings.data;
          this.mdListingTotal = 0;
          this.mdListingCount = 0;
          this.mdListingCurrentPage = 1;
          this.mdListingPages = [];

          $('#propertyList').prepend(
            $('<h2>').addClass('no-result').html('No result found!')
          );
        }
      }
    );

    this.myDesktopService.myDesktopCustomParams
    .takeUntil(this.destroy$)
    .subscribe(
      (dataCustomParams: any[]) => {
        if ( typeof dataCustomParams !== 'undefined' && dataCustomParams.length > 0 ) {
          this.mdCustomParams = dataCustomParams;
          const _params = dataCustomParams.slice();
          _params.forEach( (param) => {
            const _key = Object.keys(param)[0];
            const _values = param[_key];
            const _index = this.selectedListings.findIndex(sListings => sListings.id === +_key);

            if ( _index !== -1) {
              this.selectedListings[_index]['inspections'] = null;
              if ( typeof _values.inspections !== 'undefined' ) {
                this.selectedListings[_index]['inspections'] = _values.inspections;
              }
              this.selectedListings[_index]['sales'] = null;
              if ( typeof _values.sales !== 'undefined' ) {
                this.selectedListings[_index]['sales'] = _values.sales;
              }
            }
          });

          this.activateInsertListing = true;
          this.loadingInsertListing = false;
          this.loading = false;

          if (this.selectedListingIDs.length === 0 ) {
            this.activateInsertListing = false;
          }
        }
      }
    );

    this.vaultService.onVaultGetListing
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( typeof response !== 'undefined' && typeof response.status !== 'undefined' ) {
          this.activateInsertListing = true;
          this.loadingInsertListing = false;
          this.loading = false;

          if (this.selectedListingIDs.length === 0 ) {
            this.activateInsertListing = false;
          }

          if ( typeof response.data !== 'undefined' && typeof response.data.id !== 'undefined' ) {
            this.mdListings = this.mdListings.filter( (listing, index) => {
              if ( response.data.id === listing.id ) {
                listing.url = response.data.url;
                listing.inspections = response.data.inspections;

                return listing;
              }

              return listing;
            });
          }
        }
      }
    );

    this.domainService.onGetDomainListing
    .takeUntil(this.destroy$)
    .subscribe(
      (response: any) => {
        if ( typeof response !== 'undefined' && typeof response.status !== 'undefined' ) {
          this.activateInsertListing = true;
          this.loadingInsertListing = false;
          this.loading = false;

          if (this.selectedListingIDs.length === 0 ) {
            this.activateInsertListing = false;
          }

          if ( typeof response.data !== 'undefined' && typeof response.data.id !== 'undefined' ) {
            this.mdListings = this.mdListings.filter( (listing, index) => {

              if ( response.data.id === String(listing.id) ) {
                listing.agent1 = listing.agent_primary = response.data.agents[0];
                listing.agent2 = response.data.agents[1];

                return listing;
              }

              return listing;
            });
          }

          console.log(this.mdListings);
        }
      }
    );

    this.globalService.resetSearch
    .takeUntil(this.destroy$)
    .subscribe(
      (response: boolean) => {
        if (response) {
          
        }
      }
    );

  }

  initForm() {
    this.mdListingsForm = new FormGroup({
      'suburb': new FormControl(''),
      'classification': new FormControl(''),
      'listingtype': new FormControl(''),
      'status': new FormControl(''),
      'substatus': new FormControl(''),
      'available': new FormControl(''),
      'officeid': new FormControl(''),
      'agentid': new FormControl(''),
      'pricefrom': new FormControl(''),
      'priceto': new FormControl(''),
      'bedfrom': new FormControl(''),
      'bedto': new FormControl(''),
      'bathfrom': new FormControl(''),
      'bathto': new FormControl(''),
      'carfrom': new FormControl(''),
      'carto': new FormControl(''),
      'local_search': new FormControl('0'),
      'client_id': new FormControl(''),
      'orderby': new FormControl('modifydateDesc'),
      'multioffice': new FormControl(false)
    });
  }

  s2ValueChanged(field: string, value = '') {
    switch (field) {
      case 'classification':
        this.s2StatusDisabled = false;
        this.s2ClassificationValue = value.trim();
        this.s2SelectingCategory = true;

        if ( this.globalService.authService.getApp() === 'Designly' ) {
          let s2StatusData = [];

          this.s2SubStatusValue = '';
          this.s2SubStatusDisabled = true;
          this.s2AvailableDisabled = false;
          switch (this.s2ClassificationValue) {
            case 'residential':
              s2StatusData = [
                {id: '', text: 'Select a Type'},
                {id: 'all', text: 'All Types'},
                {id: 'listing', text: 'Sales'},
                {id: 'rental', text: 'Rental'},
                {id: 'auction', text: 'Auction'},
                {id: 'sold', text: 'Sold'},
                {id: 'conditional', text: 'Under Offer / Conditional'},
                {id: 'unconditional', text: 'Unconditional'},
                {id: 'pricechange', text: 'Price Change'},
                {id: 'appraisal', text: 'Appraisal'}
              ];
              break;
            case 'commercial':
              s2StatusData = [
                {id: '', text: 'Select a Type'},
                {id: 'all', text: 'All Types'},
                {id: 'listing', text: 'Sales'},
                {id: 'lease', text: 'Lease'},
                {id: 'salelease', text: 'For Sale & Lease'},
                {id: 'leased', text: 'Leased'},
                {id: 'sold', text: 'Sold'},
                {id: 'conditional', text: 'Under Offer / Conditional'},
                {id: 'pricechange', text: 'Price Change'},
                {id: 'appraisal', text: 'Appraisal'}
              ];
              break;
            case 'business':
              s2StatusData = [
                {id: '', text: 'Select a Type'},
                {id: 'all', text: 'All Types'},
                {id: 'listing', text: 'Sales'},
                {id: 'sold', text: 'Sold'},
                {id: 'conditional', text: 'Under Offer / Conditional'},
                {id: 'pricechange', text: 'Price Change'},
                {id: 'appraisal', text: 'Appraisal'}
              ];
              break;
            case 'rural':
              s2StatusData = [
                {id: '', text: 'Select a Type'},
                {id: 'all', text: 'All Types'},
                {id: 'listing', text: 'Sales'},
                {id: 'auction', text: 'Auction'},
                {id: 'sold', text: 'Sold'},
                {id: 'conditional', text: 'Under Offer / Conditional'},
                {id: 'pricechange', text: 'Price Change'},
                {id: 'appraisal', text: 'Appraisal'}
              ];
              break;
            case 'land':
              s2StatusData = [
                {id: '', text: 'Select a Type'},
                {id: 'all', text: 'All Types'},
                {id: 'listing', text: 'Sales'},
                {id: 'auction', text: 'Auction'},
                {id: 'sold', text: 'Sold'},
                {id: 'conditional', text: 'Under Offer / Conditional'}
              ];
              break;
            case 'holidayRental':
              s2StatusData = [
                {id: '', text: 'Select a Type'},
                {id: 'all', text: 'All Types'},
                {id: 'lease', text: 'Lease'},
                {id: 'appraisal', text: 'Appraisal'},
                {id: 'management', text: 'Management'}
              ];
              break;
            default:
              s2StatusData = [
                {id: '', text: 'Select a Type'},
                {id: 'all', text: 'All Types'},
                {id: 'listing', text: 'Sales'},
                {id: 'auction', text: 'Auction'},
                {id: 'sold', text: 'Sold'},
                {id: 'conditional', text: 'Under Offer / Conditional'},
                {id: 'pricechange', text: 'Price Change'},
              ];
              break;
          }

          if ( this.authUser.provider === 'domain' ) {
            switch (this.s2ClassificationValue) {
              default:
                s2StatusData = [
                  {id: '', text: 'Select a Type'},
                  {id: 'Sale', text: 'Sales'},
                  {id: 'Rent', text: 'Rental'},
                  {id: 'Share', text: 'Share'},
                  {id: 'Sold', text: 'Sold'},
                  {id: 'NewHomes', text: 'New Homes'}
                ];
                break;
            }
          }

          if ( this.authUser.provider === 'vaultre' ) {
            s2StatusData.forEach( (element, index) => {
              if ( element.id === 'all' ||
              element.id === 'pricechange' ||
              element.id === 'salelease' ) {
                s2StatusData.splice(index, 1);
              }
            });
            this.s2StatusData = s2StatusData;
          } else {
            this.s2StatusData = s2StatusData;
          }
          this.s2SubStatusValue = '';
        }
        break;
      case 'status':
        this.s2StatusValue = value.trim();

        if ( this.globalService.authService.getApp() === 'MyDesign3' ) {
          this.canSearch = true;
          this.s2SelectingCategory = false;
        }

        if ( this.globalService.authService.getApp() === 'Designly' ) {
          this.s2SubStatusValue = 'management';
          this.s2SubStatusDisabled = true;
          this.s2AvailableDisabled = true;

          if ( !this.s2SelectingCategory ) {
            this.s2StatusValue = value.trim();
          }

          if ( this.s2StatusValue === 'pricechange' ||
          this.s2StatusValue === 'appraisal' ||
          this.s2StatusValue === 'listing' ||
          this.s2StatusValue === 'rental' ||
          this.s2StatusValue === 'conditional' ||
          this.s2StatusValue === 'auction' ) {
            this.filterPeriodType = 'Listing Date';
          } else {
            this.filterPeriodType = 'n/a';
            this.mdListingsForm.patchValue({
              'period': 'any'
            });
          }

          if ( this.s2StatusValue === 'pricechange' ) {
            this.canSearch = false;
            this.filterPeriodType = 'Price Modify Date';
          } else {
            this.canSearch = true;
          }

          if ( this.s2StatusValue === 'auction' ) {
            this.filterPeriodType = 'Auction Date';
          }

          if ( this.s2StatusValue === 'sold' ) {
            this.canSearch = false;
          } else {
            this.mdListingsForm.patchValue({
              'basedon': ' '
            });
          }

          switch (this.s2StatusValue) {
            case 'rental':
              if (this.s2ClassificationValue === 'residential') {
                this.s2SubStatusDisabled = false;
                this.s2AvailableDisabled = false;
              }
            break;
          }
        }
        break;
      case 'substatus':
          this.s2SubStatusValue = value.trim();
          if (this.s2SubStatusValue === 'all') {
            this.s2SubStatusValue = '';
          }
        break;
      case 'available':
          this.s2AvailableValue = value.trim();
          break;
      case 'suburb':
        if (Array.isArray(value)) {
          this.s2SuburbValue = value;
        } else {
          if (this.s2SuburbValue === value) {
            value = '';
          }
          this.s2SuburbValue = value.trim();
        }
        break;
      case 'officeid':
        this.s2OfficeIdValue = value.trim();
        break;
      case 'agentid':
        this.s2AgentIdValue = value.trim();
        break;
      case 'pricefrom':
        this.s2PriceFromValue = value.trim();
        break;
      case 'priceto':
        this.s2PriceToValue = value.trim();
        break;
      case 'bedfrom':
        this.s2BedFromValue = value.trim();
        break;
      case 'bedto':
        this.s2BedToValue = value.trim();
        break;
      case 'bathfrom':
        this.s2BathFromValue = value.trim();
        break;
      case 'bathto':
        this.s2BathToValue = value.trim();
        break;
      case 'carfrom':
        this.s2CarFromValue = value.trim();
        break;
      case 'carto':
        this.s2CarToValue = value.trim();
        break;
      case 'orderby':
        this.s2OrderByValue = value.trim();
        break;
    }

    this.mdListingsForm.patchValue(
      {
        'classification' : this.s2ClassificationValue,
        'status' : this.s2StatusValue,
        'substatus' : this.s2SubStatusValue,
        'suburb' : this.s2SuburbValue,
        'officeid' : this.s2OfficeIdValue,
        'agentid' : this.s2AgentIdValue,
        'pricefrom' : this.s2PriceFromValue,
        'priceto' : this.s2PriceToValue,
        'bedfrom' : this.s2BedFromValue,
        'bedto' : this.s2BedToValue,
        'bathfrom' : this.s2BathFromValue,
        'bathto' : this.s2BathToValue,
        'carfrom' : this.s2CarFromValue,
        'carto' : this.s2CarToValue,
        'local_search': this.client.is_local_search,
        'client_id': this.client.ID,
        'orderby' : this.s2OrderByValue,
        'available': this.s2AvailableValue
      }
    );

    if ( !this.s2SelectingCategory && this.canSearch ) {
      this.listingSearchChange('');
    }

    if ( field !== 'classification' && this.s2SelectingCategory ) {
      this.s2SelectingCategory = false;
    }
  }

  listingSearchChange(current, page = 1) {
    this.loading = true;
    const formValues = this.mdListingsForm.value;

    this.mdListingCount = 0;
    this.mdListingTotal = 0;
    this.mdListingPages = [];
    this.mdListingCurrentPage = 1;

    if (page > 0) {
      formValues['page'] = page;
      this.mdListingCurrentPage = page;
    }

    if ( this.isMultipleOffice && formValues['officeid'] ) {
      const officeData = this.authUser.multiple.slice(0);
      const officeIndex = officeData.findIndex(sOffice => sOffice.groupid === +formValues['officeid']);

      if ( officeIndex >= 0 && typeof officeData[officeIndex] !== 'undefined' ) {
        formValues['office_token'] = officeData[officeIndex].token;
      }
    }

    this.selectedListingIDs = [];
    this.listingSearchValues = formValues;

    this.myDesktopService.httpGetMDListings(
      formValues,
      this.authUser.provider
    );
  }

  selectProperty(listing, elRef: HTMLElement) {
    const isIndex = this.selectedListings.findIndex(sListing => sListing.id === listing.id);
    const indexOfListingID = this.selectedListingIDs.indexOf(listing.id);

    if ( this.page === 'builder' ) {
      if (this.globalService.template.category_id === 4 || this.globalService.template.category_id === 8) {
        this.globalService.element_listing_limit = 1;
      }

      if ( this.globalService.template.category_id !== 5 && ( this.globalService.element_listing_limit !== 0 &&
        this.selectedListings.length >= this.globalService.element_listing_limit ) ) {
        if (isIndex === -1) {
          swal('Listing limit of ' + this.globalService.element_listing_limit + ' reached.');
          return false;
        }
      }
    } else {
      this.globalService.element_listing_limit = 1;
      if ( this.selectedListings.length >= this.globalService.element_listing_limit ) {
        swal('Listing limit of ' + this.globalService.element_listing_limit + ' reached.');
        return false;
      }
    }

    if (isIndex === -1) {
      this.selectedListingIDs.push(listing.id);
      this.selectedListings.push(listing);
      elRef.classList.add('selected');
      $(elRef).find( 'input' ).prop('checked', true);
    } else {
      this.selectedListingIDs.splice(indexOfListingID, 1);

      this.selectedListings.splice(isIndex, 1);
      elRef.classList.remove('selected');
      $(elRef).find( 'input' ).prop('checked', false);

    }

    if ( this.globalService.authService.getApp() === 'MyDesign3' ) {
      if ( this.selectedListings.length > 0 ) {
        this.getCustomParams(listing.id);
        this.subLoading = true;
      }
    } else {
      if ( this.authUser.provider === 'domain' ) {
        this.domainService.httpGetListing(listing.id);
        this.loadingInsertListing = true;
        this.activateInsertListing = false;
      }
  
      if ( this.authUser.provider === 'vaultre' ) {
        this.vaultService.httpGetListing(listing.id, this.listingSearchValues);
        this.loadingInsertListing = true;
        this.activateInsertListing = false;
      }
    }

    this.activateInsertListing = false;
    this.loadingInsertListing = true;
    this.loading = true;
  }

  getCustomParams(property_id: number) {
    this.myDesktopService.httpGetMDListingByCustomParams(
      {
        ID: property_id
      }
    );
  }

  clearListingResult() {
    this.mdListings = [];
    this.mdListingTotal = 0;
    this.mdListingCount = 0;
    this.mdListingCurrentPage = 1;
    this.mdListingPages = [];
  }

  onCheckMulti() {
    const isMulti = $('#multi-office').is(':checked');
    this.mdListingsForm.patchValue({
      'multioffice': isMulti
    });
    if ( !this.s2SelectingCategory && this.canSearch ) {
      this.listingSearchChange('');
    }
  }

  onPaginate(type) {
    const formValues = [];
    if ( type === 'prev' ) {
      formValues['paginate_link'] = this.designlyPreviousLink;
    }

    if ( type === 'next' ) {
      formValues['paginate_link'] = this.designlyNextLink;
    }

    this.myDesktopService.httpGetMDListings(
      formValues,
      'vault'
    );
  }

  reorderImages(listing) {
    this.loading = true;

    this._tmp_order_id = listing.id;

    if ( typeof this._tmp_order_images[this._tmp_order_id] !== 'undefined' ) {
      this.listingImages = this._tmp_order_images[this._tmp_order_id];
    } else {
      this.listingImages = listing.images;
    }

    $('#mdReorderImage').modal('show');

    setTimeout(() => {
      $('#sortable').sortable();
      $( '#sortable' ).disableSelection();
      this.loading = false;
    }, 1000);
  }

  saveImageOrder() {
    const _tmp_order = [];

    $('#sortable').find('li').each( function() {
      _tmp_order.push( { url: $(this).find('img').attr('src') } );
    });

    this._tmp_order_images[this._tmp_order_id] = _tmp_order;
    $('#mdReorderImage').modal('hide');
    swal({
      position: 'top-end',
      type: 'success',
      title: 'Order saved',
      showConfirmButton: false,
      timer: 1500
    }).catch(swal.noop);
  }

  onSelectListings() {
    this.globalService.onSelectListing.next(this.selectedListings);
    setTimeout(
      () => {
        this.mdListingsForm.reset();
        this.mdListingsForm.setValue({
          'suburb': '',
          'classification': '',
          'listingtype': '',
          'status': '',
          'officeid': '',
          'agentid': '',
          'pricefrom': '',
          'priceto': '',
          'bedfrom': '',
          'bedto': '',
          'bathfrom': '',
          'bathto': '',
          'carfrom': '',
          'carto': '',
          'local_search': '0',
          'client_id': '',
          'orderby': 'modifydateDesc',
          'substatus': '',
          'available': '',
          'multioffice': false
        });
        // this.mdPropSearchModalClose.nativeElement.click();
        this.loading = false;
      }, 200
    );

    this.selectedListings = [];
    this.selectedListingIDs = [];
    
    $('.selected').removeClass('selected');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/property-search/property-search.component.ts